export default "__VITE_ASSET__BxW5U0AO__"